<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>采购单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="采购单号" prop="number">
            <el-input
              size="small"
              v-model="filter.number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="订单状态" prop="status">
            <el-select
              size="small"
              v-model="filter.status"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, key) in purchaseOrderStatusMap"
                :key="key"
                :label="item.name"
                :value="key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestOrders()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleNew"
          v-permission="Auth.purchaseOrderNew"
          >新采购单</el-button
        >
        <file-button
          style="float: right"
          :filter="filter"
          obj="purchase_order"
          :importButton="false"
          v-permission="Auth.purchaseOrderIE"
        ></file-button>
      </div>
      <el-table v-if="!isMobile()" :data="orders" v-loading="loading">
        <el-table-column prop="number" label="采购单号 / 订单号" width="200">
          <template slot-scope="scope">
            <purchase-link
              :id="scope.row.id"
              :number="scope.row.number"
              :origin="0"
            ></purchase-link>
            <br />
            {{ scope.row.customer_order.number }}
          </template>
        </el-table-column>
        <el-table-column label="产品明细">
          <template slot-scope="scope">
            <span class="item-tag" v-for="item in scope.row.items">
              {{ item.item.name }}
              <i>x{{ item.count }}</i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user.name"
          align="center"
          label="创建人"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="创建日期"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="110" align="center">
          <template slot-scope="scope">
            <status-tag
              :type="purchaseOrderStatusMap[scope.row.status].type"
              :name="purchaseOrderStatusMap[scope.row.status].name"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="120"
        ></el-table-column>
        <el-table-column align="right" label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <purchase-link
                :id="scope.row.id"
                :number="scope.row.number"
                :origin="0"
                v-permission="Auth.purchaseOrderShow"
                style="margin-right: 5px"
              >
                <el-button slot="content" size="mini" type="primary" plain
                  >查看</el-button
                >
              </purchase-link>
              <el-button
                slot="reference"
                size="mini"
                type="primary"
                plain
                v-if="hasOrderApplicationAuth(scope.row)"
                @click="handleApplication(scope.row, scope.$index)"
                v-permission="Auth.purchaseOrderNew"
                >申请</el-button
              >
              <el-button
                size="mini"
                type="primary"
                plain
                @click="handleApprove(scope.row, scope.$index)"
                v-if="scope.row.status == 3"
                v-permission="Auth.purchaseOrderApprove"
                >审批</el-button
              >
            </div>
            <div style="margin-top: 5px" v-if="hasOrderEditAuth(scope.row)">
              <el-button
                size="mini"
                type="primary"
                plain
                style="margin-right: 5px"
                @click="handleEdit(scope.row, scope.$index)"
                v-permission="Auth.purchaseOrderEdit"
                >编辑</el-button
              >
              <el-popconfirm
                title="确认删除吗？"
                @confirm="handleDelete(scope.row, scope.$index)"
                v-permission="Auth.purchaseOrderDelete"
              >
                <el-button slot="reference" type="danger" plain size="mini"
                  >删除</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in orders">
          <div>
            <purchase-link
              :id="item.id"
              :number="item.number"
              :origin="0"
            ></purchase-link>
          </div>
          <div class="font-12" v-if="item.customer_order.number">
            <order-link
              class="text-black"
              :order="item.customer_order"
            ></order-link>
          </div>
          <div class="flex-row-between font-12">
            <span>创建人：{{ item.user.name }}</span>
            <span class="text-gray">
              {{ formatTime(item.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </div>
          <div class="font-12" v-if="item.remark">{{ item.remark }}</div>
          <div>
            <status-tag
              class="font-12"
              :type="purchaseOrderStatusMap[item.status].type"
              :name="purchaseOrderStatusMap[item.status].name"
            ></status-tag>
          </div>
          <div>
            <purchase-link
              :id="item.id"
              :number="item.number"
              :origin="0"
              v-permission="Auth.purchaseOrderShow"
              style="margin-right: 5px"
            >
              <el-button slot="content" size="mini" type="primary" plain
                >查看</el-button
              >
            </purchase-link>
            <el-button
              slot="reference"
              size="mini"
              type="primary"
              plain
              v-if="hasOrderApplicationAuth(item)"
              @click="handleApplication(item, index)"
              v-permission="Auth.purchaseOrderNew"
              >申请</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleApprove(item, index)"
              v-if="item.status == 3"
              v-permission="Auth.purchaseOrderApprove"
              >审批</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              style="margin-right: 5px"
              @click="handleEdit(item, index)"
              v-permission="Auth.purchaseOrderEdit"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除吗？"
              @confirm="handleDelete(item, index)"
              v-permission="Auth.purchaseOrderDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
          </div>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        @current-change="handlePageChange"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <purchase-order-former
      :model="model"
      :show.sync="dialogVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></purchase-order-former>

    <order-detail-dialog
      :model="detailModel"
      :show.sync="detailDialogVisible"
    ></order-detail-dialog>
    <purchase-order-application
      :model="application"
      :show.sync="applicationDialogVisible"
      @updated="updatedCallback"
    ></purchase-order-application>
  </div>
</template>

<script>
import purchaseOrderApplication from '@/components/purchase_order_application'
import orderDetailDialog from '@/components/bill_detail'
import purchaseOrderFormer from '@/components/purchase_order'
import {
  purchaseOrderList,
  deletePurchaseOrder,
  purchaseOrderStatusChange,
} from '../../service/getData'
import { PurchaseOrderStatusMap } from '../../config/global'
import { clone } from '@/util'
import { formatTime } from '@/util/index'
import auth from '@/util/auth'
import store from '@/store/store'
import { isMobile } from '../../util'

export default {
  components: {
    purchaseOrderApplication,
    purchaseOrderFormer,
    orderDetailDialog,
  },
  data() {
    return {
      filter: {
        number: '',
        status: '',
        date: null,
        size: 20,
        page: 1,
      },
      auth,
      isMobile,
      userInfo: store.state.userInfo,
      model: {
        customer_order_id: '',
        remark: '',
        items: [],
        type: 1,
        status: 1,
      },
      detailModel: {},
      total: 0,
      sales: [],
      orders: [],
      purchaseOrderStatusMap: PurchaseOrderStatusMap,
      formatTime: formatTime,
      loading: false,
      editIndex: 0,
      dialogVisible: false,
      detailDialogVisible: false,
      application: {},
      applicationDialogVisible: false,
    }
  },
  created() {
    this.requestOrders()
  },
  methods: {
    async requestOrders() {
      let data = clone(this.filter)
      data.page = data.page - 1
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      this.loading = true
      let res = await purchaseOrderList(data)
      if (res.code == 0) {
        this.orders = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    hasOrderApplicationAuth(order) {
      return (
        this.userInfo.id == order.creator_id &&
        (order.status == 1 || order.status == 5)
      )
    },
    hasOrderEditAuth(order) {
      return this.userInfo.id == order.creator_id && order.status != 9
    },
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.requestOrders()
    },
    handlePageChange(e) {
      this.filter.page = e
      this.requestOrders()
    },
    showOrderDetail(item) {
      item.items.map((it) => {
        it.unit_price = it.price
        it.item_number = it.count
      })
      this.detailDialogVisible = true
      this.detailModel = item
    },
    handleNew() {
      this.dialogVisible = true
      this.model = {
        customer_order_id: '',
        remark: '',
        items: [],
        type: 1,
        status: 1,
      }
    },
    handleEdit(item, index) {
      this.editIndex = index
      this.dialogVisible = true
      this.$nextTick(() => {
        this.model = clone(item)
        this.model.items.map((it) => {
          it.id = it.item.id
          it.category = it.item.category
          it.name = it.item.name
          it.part_number = it.item.part_number
          it.machine_type = it.item.machine_type
        })
        if (this.model.customer_order_id == 0) {
          this.model.customer_order_id = ''
        }
      })
    },
    handleApplication(item, index) {
      this.editIndex = index
      this.application = {
        id: item.id,
        number: item.number,
        approver_id: '',
      }
      this.applicationDialogVisible = true
    },
    handleApprove(item, index) {
      let that = this
      this.$confirm('请选择审批结果', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        center: true,
      })
        .then(() => {
          purchaseOrderStatusChange({
            id: item.id,
            status: 7,
          }).then((res) => {
            that.$set(that.orders, index, res.data)
          })
        })
        .catch((action) => {
          if (action === 'cancel') {
            purchaseOrderStatusChange({
              id: item.id,
              status: 5,
            }).then((res) => {
              that.$set(that.orders, index, res.data)
            })
          }
        })
    },
    async handleDelete(item, index) {
      let res = await deletePurchaseOrder(item.id)
      if (res.code == 0) {
        this.orders.splice(index, 1)
      }
    },
    createdCallback(data) {
      this.orders.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.orders, this.editIndex, data)
    },
  },
}
</script>

<style scoped>
.el-input {
  width: 220px;
}
.tag {
  float: left;
  max-width: 100%;
  text-overflow: ellipsis;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  border: 1px solid #ccc;
  font-size: 12px;
  margin: 2px 0;
  clear: both;
  background-image: linear-gradient(to right, #98c9fd55, #fff);
}
.tag i {
  margin-left: 10px;
}
</style>